import { Sparkles } from "lucide-react"
import { cn } from "@/lib/utils"
import { Checkbox } from "../Checkbox/Checkbox"

/**
 * The composer's Auto-verify switch. Ticked means that after the AI generates code it
 * replays it over the trade ideas drawn on the chart, compares the orders with the
 * drawings and fixes mismatches on its own, up to a round limit, before handing over.
 * Unticked is the manual flow: the walkthrough is offered as a button instead.
 *
 * A standing preference, not a per-message option — there is nothing to arm or
 * disarm on a send.
 */

export const AGENTIC_TOGGLE_TITLE =
  "After generating code, replay it over your drawings and fix mismatches automatically (up to 3 rounds)."

export interface AgenticToggleProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
}

export function AgenticToggle({ checked, onCheckedChange, disabled = false, className }: AgenticToggleProps) {
  return (
    <div className={cn("flex items-center gap-1.5 shrink-0", className)} title={AGENTIC_TOGGLE_TITLE}>
      <Checkbox
        id="agentic-toggle"
        checked={checked}
        disabled={disabled}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        className="h-3.5 w-3.5 shrink-0"
      />
      <label
        htmlFor="agentic-toggle"
        className={cn(
          "flex items-center gap-1 text-caption text-muted-foreground whitespace-nowrap shrink-0 select-none",
          disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
        )}
      >
        <Sparkles size={12} strokeWidth={1.75} aria-hidden="true" className="shrink-0" />
        Auto-verify
      </label>
    </div>
  )
}
